import { Tab, Tabs } from 'vant'
import { Component, Mixins } from 'vue-property-decorator'
import { SuperMixin } from '../../category.mixin'
import { DiscountsMixin } from '@shared/mixins/discounts'
import Consultant from '../consultant/consultant.vue'
import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

import { flatMapDeep, includes, intersectionWith, map, join } from 'lodash'
import { CARESSTUINA } from '@constant/index'
import { toV } from '@utils/index'
@Component({
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Consultant
  }
})
export default class SelfOperatedComponent extends Mixins(DiscountsMixin, SuperMixin) {
  [x: string]: any
  public tabSelect = 0

  @categoryModule.State categoryList!: any[]
  @categoryModule.State selfOperatedData!: any

  get nearStore() {
    return this.selfOperatedData && this.selfOperatedData.nearStore
  }

  get consultantList() {
    return this.selfOperatedData && this.selfOperatedData.worker
  }

  get spuList() {
    return this.selfOperatedData && this.selfOperatedData.spuList
  }
  get spuIds() {
    return this.spuList && flatMapDeep(this.spuList, (item: any) => map(item, (o: any) => o.spuId))
  }
  get tabCategoryList() {
    const categoryHasIds = includes(CARESSTUINA, this.categoryId)
    const list = categoryHasIds ? CARESSTUINA : [this.categoryId]
    return intersectionWith(this.categoryList, list, (pre: any, next: string) => pre.value == next)
  }

  changeTag(index: number) {
    this.tabSelect = index
  }

  get hasSelfOperated() {
    return this.spuList && this.spuList.length > 0
  }
  
  hasDiscounts(item: any) {
    // 判断是否有优惠
    const self: any = this
    return self && self.$options && self.$options?.filters['discounts'](item)
  }
  handleMore() {
    const spuIds = join(this.spuIds, ',')
    const { swt, refresh } = this.$route.query
    this.$router.push({ name: 'consultantList', query: { swt, spuIds, refresh } })
  }
  toProduct(spuId: string) {
    toV({ name: 'product-detail', params: { spuId }, query: { refresh: 'no' } })
  }
  toStore(stroe: any) {
    location.href = `//w.cekid.com/store/info.html?code=${stroe.storeCode}`
  }
}
